import Head from "next/head";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect,useState } from 'react';
import { PageLayout } from '@/components/mobile';
import { _getURL } from "@/api/index";
import { HeaderBack } from '@/components/common/header';
import { Footer } from '../components/common/footer';
import { MyBody } from "../components/body/body";
import { TextInput, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { toast } from "@/libraries/swal";

export default function Index(props) {
    const { t, device, session } = props;

    const { getInputProps, onSubmit, isValid, values, setFieldError, reset, setFieldValue, clearFieldError } = useForm({
        validateInputOnChange: true,
        initialValues: {
            name: '',
            email: '',
            message: '',
        },
        validate: {
            name: (inputValue) => inputValue.length <= 0 && "Name Cannot Be Empty",
            email: (inputValue) => inputValue.length <= 0 && "e-mail Cannot Be Empty",
            message: (inputValue) => inputValue.length <= 0 && "Message Cannot Be Empty",
        }
    });

    const _submitMessage = async(value) => {
        try{
            await toast.success("Thank you for your message. We will contact you shortly.");
            location.reload();
        } catch (error) {
            toast.error(error)
        }
    }

    return (
        <>
            <Head>
                <title>Contact Us - KeyAuto.my</title>
                <meta key="standard-title" name="title" content="Contact Us - KeyAuto.my" />
                <meta key="standard-description" name="description" content="Contact Us - KeyAuto.my" />
                <meta key="og:title" property="og:title" content="Contact Us - KeyAuto.my" />
                <meta key="og:description" property="og:description" content="Contact Us - KeyAuto.my" />
                <meta key="og:url" property="og:url" content="https://keyauto.my/contactus/" />
                <meta name="twitter:label1" content="Est. reading time" />
                <meta name="twitter:data1" content="5 minutes" />
                <link rel="canonical" href="https://keyauto.my/contactus/" />
            </Head>
            <MyBody
                t={t}
                containerClass={"contactUsContainer"}
                headerComponent={
                    <HeaderBack 
                        searchVisible={false} 
                        menuVisible={false}
                        t={t}
                    />
                }
            >
                <div className='contactUsContent containerPadding'>
                    <p className='fontSize_16 fontWeight_semiBold'>
                        {t('contact_us')}
                    </p>
                    <br />
                    <p className='fontSize_12'>
                        {t('contactus_info')}
                    </p>
                    <br />
                    <form onSubmit={onSubmit((values) => _submitMessage(values))}>
                        <TextInput 
                            type='text'
                            placeholder={t('name')}
                            classNames={{
                                input: "fontSize_12",
                                error: "fontSize_12 fontColor_red"
                            }}
                            {...getInputProps('name')}
                        />
                        <br />
                        <TextInput 
                            type='text'
                            placeholder={t('email')}
                            classNames={{
                                input: "fontSize_12",
                                error: "fontSize_12 fontColor_red"
                            }}
                            {...getInputProps('email')}
                        />
                        <br />
                        <Textarea 
                            minRows={7}
                            maxRows={7}
                            maxLength={100}
                            placeholder={t('message')}
                            classNames={{
                                input: "fontSize_12",
                                error: "fontSize_12 fontColor_red"
                            }}
                            {...getInputProps('message')}
                        />
                        <br />
                        <button type="submit" disabled={isValid() ? false : true} className="vehicleWriteReviewPage_submitButton primaryButtonBackground">
                            <p className="fontSize_16 fontWeight_bold fontColor_white">
                                {t('submit')}
                            </p>
                        </button>
                    </form>
                </div>
            </MyBody>
        </>
    )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}